import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const VoidLineItemModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "VoidLineItemModalContainer" */
      './VoidLineItemModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
